<script>
import axios from "axios";
import LessonInstance from "@/components/ll/lesson-instance.vue";
import {toast} from "vue3-toastify";

export default {
  name: "my_lessons",
  components: {LessonInstance},
  props: ['admin'],
  data(){
    return {
      lessons:[],
      current_lesson:null,
      // Možnosti pro filtry
      companies: [],
      students: [],
      lectors: [],
      languages: [],
      // Vybrané filtry
      selectedBType: '',
      selectedCompany: null,
      selectedStudent: null,
      selectedLector: null,
      selectedState: '',
      selectedLessonType: '',
      selectedLanguage: null,
      searchGroupName: '',
      dateFrom: '',
      dateTo: '',
      datePreset: '',
      searchDebounceTimer: null
    }
  },
  mounted() {
    this.loadLessons()
  },
  methods:{


    setStatus(l,value){

      axios.put(`/ll/lesson-instances/${l.id}/set-status.json`, {status: value}).then(re=>{
        if (re.status===200){
          this.loadLessons()
          toast.success("Status lekce změněn")
        }
      }).catch(e=>{
        toast.error("Chyba při změně statusu lekce: "+e.response.data.message)
      })


    },


    datetime_human(dateStr){
      const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' };
      return new Date(dateStr).toLocaleDateString(undefined, options);
    },
    loadLessons(){
      const url = `/ll/lesson_instances.json`
      axios.get(url, {
        params: this.get_lesson_params()
      }).then( response => {
        this.lessons = response.data.items
        this.companies = response.data.companies
        this.students = response.data.students
        this.lectors = response.data.lectors
        this.languages = response.data.languages
      }).catch(error => {
        console.error('Došlo k chybě při načítání lekcí:', error);
      })
    },

    get_lesson_params(){
      const params = {
        b_type: this.selectedBType,
        company_id: this.selectedCompany,
        student_id: this.selectedStudent,
        lector_id: this.selectedLector,
        state: this.selectedState,
        lesson_type: this.selectedLessonType,
        language_id: this.selectedLanguage,
        group_name: this.searchGroupName,
        date_from: this.dateFrom,
        date_to: this.dateTo,
        date_preset: this.datePreset
      };

      // Odstranit null, undefined a prázdné řetězce
      return Object.fromEntries(
        Object.entries(params).filter(([_, value]) =>
          value !== null && value !== undefined && value !== ''
        )
      );
    },

    xlsxExport(){
      const params = this.get_lesson_params();
      const queryString = new URLSearchParams(params).toString();
      const url = `/ll/lesson_instances/export.xlsx${queryString ? '?' + queryString : ''}`;

      // Vytvoření dočasného odkazu pro stažení
      window.location.href = url;
    },

    handleGroupNameInput() {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.loadLessons();
      }, 500);
    },
    handleDatePresetChange() {
      if (this.datePreset === 'last_month') {
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        const lastDay = new Date(now.getFullYear(), now.getMonth(), 0);
        this.dateFrom = firstDay.toISOString().split('T')[0];
        this.dateTo = lastDay.toISOString().split('T')[0];
      } else {
        this.dateFrom = '';
        this.dateTo = '';
      }
      this.loadLessons();
    },
    editLessonInstance(lesson){
      this.current_lesson = lesson
      this.$refs.lessonInstanceDialog.showModal()
    },
    deleteLessonInstance(lesson){
      if (confirm("Opravdu smazat tuto lekci?")){
        axios.delete(`/ll/lesson_instances/${lesson.id}.json`).then(re=>{
          if (re.status===200){
            this.loadLessons()
            toast.success("Lekce smazána")
          }
        }).catch(e=>{
          toast.error("Chyba při mazání lekce: "+e.response.data.message)
        })
      }
    }
  }
}/*
Filtr - od data do data (případně last calendar month),
podle Company,
podle Student/s,
podle stavu (inserted, approved, denied, all),
podle Types of lessons (on-to-one, 2 students (jen u B2B lekcí), group (jen u B2B lekcí), all)


vzor dat
   [
  {
    "id": 1,
    "when": "2026-01-02T21:56:00.000+01:00",
    "minutes": 45,
    "lecturer_id": 70,
    "lesson_topic": "dwedwed",
    "feedback": "wedwedwed",
    "lesson_state": "lesson_took_place",
    "additional_information": "wdwe",
    "next_lesson": null,
    "ll_lesson_id": 3,
    "students": [],
    "lecturer": {
      "id": 70,
      "email": "kate.duchackova@gmail.com",
      "first_name": "Katka",
      "last_name": "Ducháčková"
    },
    "lesson": {
      "id": 3,
      "lesson_type": "two_students",
      "language_level": null
    }
  },
*/

</script>

<template>
<div>
  <h3>Přehled odučených lekcí</h3>

  <div class="card mb-3">
    <div class="card-body">
      <h5>Filtry</h5>

      <div class="row">
        <!-- B2B/B2C -->
        <div class="col-md-3 mb-2">
          <label>Typ business</label>
          <select v-model="selectedBType" class="form-control" @change="loadLessons">
            <option value="">Všechny</option>
            <option value="b2b">B2B</option>
            <option value="b2c">B2C</option>
          </select>
        </div>

        <!-- Datum preset -->
        <div class="col-md-3 mb-2">
          <label>Časové období</label>
          <select v-model="datePreset" class="form-control" @change="handleDatePresetChange">
            <option value="">Vlastní rozsah</option>
            <option value="last_month">Minulý kalendářní měsíc</option>
          </select>
        </div>

        <!-- Od data -->
        <div class="col-md-3 mb-2">
          <label>Od data</label>
          <input type="date" v-model="dateFrom" class="form-control" @change="loadLessons">
        </div>

        <!-- Do data -->
        <div class="col-md-3 mb-2">
          <label>Do data</label>
          <input type="date" v-model="dateTo" class="form-control" @change="loadLessons">
        </div>
      </div>

      <div class="row">
        <!-- Společnost -->
        <div class="col-md-3 mb-2">
          <label>Společnost</label>
          <select v-model="selectedCompany" class="form-control" @change="loadLessons">
            <option :value="null">-- Všechny společnosti --</option>
            <option v-for="company in companies" :key="company.id" :value="company.id">
              {{ company.name }}
            </option>
          </select>
        </div>

        <!-- Student -->
        <div class="col-md-3 mb-2">
          <label>Student</label>
          <select v-model="selectedStudent" class="form-control" @change="loadLessons">
            <option :value="null">-- Všichni studenti --</option>
            <option v-for="student in students" :key="student.id" :value="student.id">
              {{ student.name }} {{ student.surname }} ({{ student.email }})
            </option>
          </select>
        </div>

        <!-- Lektor -->
        <div class="col-md-3 mb-2">
          <label>Lektor</label>
          <select v-model="selectedLector" class="form-control" @change="loadLessons">
            <option :value="null">-- Všichni lektoři --</option>
            <option v-for="lector in lectors" :key="lector.id" :value="lector.id">
              {{ lector.first_name }} {{ lector.last_name }}
            </option>
          </select>
        </div>

        <!-- Stav -->
        <div class="col-md-3 mb-2">
          <label>Stav</label>
          <select v-model="selectedState" class="form-control" @change="loadLessons">
            <option value="">Všechny</option>
            <option value="inserted">Inserted</option>
            <option value="approved">Approved</option>
            <option value="denied">Denied</option>
          </select>
        </div>
      </div>

      <div class="row">
        <!-- Typ lekce -->
        <div class="col-md-3 mb-2">
          <label>Typ lekce</label>
          <select v-model="selectedLessonType" class="form-control" @change="loadLessons">
            <option value="">Všechny</option>
            <option value="one_to_one">One-to-one</option>
            <option value="two_students" v-if="selectedBType !== 'b2c'">2 students</option>
            <option value="group" v-if="selectedBType !== 'b2c'">Group</option>
          </select>
        </div>

        <!-- Jazyk -->
        <div class="col-md-3 mb-2">
          <label>Jazyk</label>
          <select v-model="selectedLanguage" class="form-control" @change="loadLessons">
            <option :value="null">-- Všechny jazyky --</option>
            <option v-for="language in languages" :key="language.id" :value="language.id">
              {{ language.name }}
            </option>
          </select>
        </div>

        <!-- Group name (pouze B2B) -->
        <div class="col-md-3 mb-2" v-if="selectedBType === 'b2b' || selectedBType === ''">
          <label>Název skupiny</label>
          <input
            type="text"
            v-model="searchGroupName"
            class="form-control"
            @input="handleGroupNameInput"
            placeholder="Hledat podle názvu skupiny"
          >
        </div>


        <div  class="col-md-1">
          <button @click="xlsxExport" class="btn btn-success">
            <span class="material-icons-outlined">download</span>
            Export XLSX
          </button>
        </div>

      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>When</th>
            <th>Students</th>
            <th>Minutes</th>
            <th>Lecturer</th>
            <th>Lesson Type</th>
            <th>Lesson Topic</th>
            <th>Lesson state</th>
            <th>Status</th>
            <th>Akce</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="lesson in lessons" :key="lesson.id">
            <td>{{ datetime_human(lesson.when) }}</td>
            <td>
              <ul class="list-unstyled mb-0 small">
                <li v-for="student in lesson.students" :key="student.id">
                  <a :href="`/students/${student.id}`" target="_blank">{{ student.name }} {{ student.surname }} ({{ student.email }})</a>
                </li>
              </ul>
            </td>
            <td>{{ lesson.minutes }}</td>
            <td>{{ lesson.lecturer.first_name }} {{ lesson.lecturer.last_name }}</td>
            <td>{{ lesson.lesson.lesson_type }}</td>
            <td>{{lesson.lesson_topic }}</td>
            <td>{{lesson.lesson_state}}</td>
            <td>{{lesson.status}}</td>

            <td class="actions">

              <a  href="#" title="schválit" v-if="lesson.status=='inserted' && admin" @click.prevent="setStatus(lesson,'approved')"><span class="material-icons-outlined">thumb_up</span></a>
              <a  href="#" title="zamítnout" v-if="lesson.status=='inserted' && admin" @click.prevent="setStatus(lesson,'denied')"><span class="material-icons-outlined">thumb_down</span></a>
              <a v-if="admin || lesson.status==='inserted'" href="#" title="upravit" @click.prevent="editLessonInstance(lesson)"><span class="material-icons-outlined">mode_edit_outline</span></a>
              <a v-if="admin || lesson.status==='inserted'" href="#" title="smazat" @click.prevent="deleteLessonInstance(lesson)"><span class="material-icons-outlined mazani">delete</span></a>


            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <lesson-instance :instance="current_lesson" ref="lessonInstanceDialog" @save-lesson-instance="loadLessons"></lesson-instance>
</div>
</template>

<style scoped>

</style>